module.exports = __webpack_public_path__ + "img/reloadicon.b970f331.svg";